export enum AuthenticationFactor {
    Email = 'email',
    Phone = 'phone',
    Totp = 'totp',
    Recoverycode = 'recoverycode',
    Custom = 'custom',
}
